module.exports = __webpack_public_path__ + "img/2024-01.f9922c35.jpg";